import { AirAirlineDTO, AirEventDTO, AirLocationDTO, AirRouteSegmentDTO, AirShipmentDTO } from "../api/response.types";
import { AirTransportModesModel } from "entities/shared/airCard.types";

import { AirTransformedEventDTO } from "../api/parser";

export type AirLocationModel = AirLocationDTO & {
  countryCode: string | null;
};

export type AirAirlineModel = AirAirlineDTO;
export type AirShipmentModel = AirShipmentDTO;
export type AirEventModel = AirEventDTO;
export type AirRouteSegmentModel = AirRouteSegmentDTO;

/** Alias used by map markers (same as transport mode). */
export const AirTransportTypeModel = AirTransportModesModel;

/** Flight leg shown in AirlineList (built from route_segments). */
export type AirFlightLegModel = {
  flightNumber: string | null;
  origin: string | null;
  destination: string | null;
  atd: string | null;
  etd: string | null;
  ata: string | null;
  eta: string | null;
  transportType: string | null;
};

/** @deprecated Prefer AirFlightLegModel for AirlineList rows */
export type AirLineModel = AirFlightLegModel;

export type AirReferenceModel = string;

export type AirEnrichedEventModel = AirEventModel & {
  locationData: AirLocationModel | null;
  locationLabel: string | null;
  displayDateTime: string | null;
  isActual: boolean;
};

export type AirGroupedEventsModel = {
  location: AirLocationModel | null;
  locationLabel: string | null;
  locationRole: "Origin" | "Destination" | "Transit" | null;
  events: AirEnrichedEventModel[];
};

export type AirShipmentTimelineModel = {
  awbNumber: string;
  cargoLabel: string;
  status: string;
  lastUpdatedAt: string | null;
  events: AirGroupedEventsModel[];
};

export type AirTransformedEventModel = Omit<AirTransformedEventDTO, "events"> & {
  events: AirEventModel[];
};
